import { CONFIG } from '../../../config'
import { parseToMysqlFormat } from '../../util/date.service'

const { ENVIROMENT } = CONFIG
const MAIN_BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/receive-vehicle`
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

export function urlGetReceiveVehicles(tp_id, pInicial, pFinal, user_id) {
  return `${MAIN_BASE_URL}/vehicles-v2/${tp_id}?pInicial=${pInicial}&pFinal=${pFinal}&user_id=${user_id}`
}

export function urlGetReceiveVehiclesByNF(tp_id, notaFiscal, pInicial, pFinal, user_id) {
  return `${MAIN_BASE_URL}/vehicles-v2/${tp_id}/${notaFiscal}?pInicial=${pInicial}&pFinal=${pFinal}&user_id=${user_id}`
}

export function urlGetReceiveVehiclesByCidade(tp_id, cidade, pInicial, pFinal, user_id) {
  return `${MAIN_BASE_URL}/vehicles-v2-by-city/${tp_id}/${encodeURIComponent(cidade)}?pInicial=${pInicial}&pFinal=${pFinal}&user_id=${user_id}`
}

export function urlGetExportReceiveVehicles(tp_id, user_id) {
  return `${MAIN_BASE_URL}/vehicles/${tp_id}/export?user_id=${user_id}`
}

export function urlGetExportReturnedVehicles(tp_id, user_id) {
  return `${MAIN_BASE_URL}/returned-vehicles/${tp_id}/export?user_id=${user_id}`
}

export function urlGetDeliveries(fleet_id) {
  return `${MAIN_BASE_URL}/deliveries/${fleet_id}`
}
export function urlPutDeliveriedDate(delivery_event_id) {
  return `${MAIN_BASE_URL}/delivery-date/${delivery_event_id}`
}
export function urlPutDeliveryEventAttempt(delivery_event_id) {
  return `${MAIN_BASE_URL}/delivery-event-attempt/${delivery_event_id}`
}
// Entrega Total
export function urlPostVehiclesDeliverySucceed(tp_id, user_id) {
  return `${MAIN_BASE_URL}/vehicles-delivery-succeeded/${tp_id}/${user_id}`
}
// Entregas Actions
export function urlPostEntregasAction(tp_id, user_id) {
  return `${MAIN_BASE_URL}/deliveries-action/${tp_id}/${user_id}`
}
export function urlPutRetornarVeiculo(fleet_id) {
  return `${MAIN_BASE_URL}/returned-vehicle/${fleet_id}`
}

export function urlRelatorioRetornoVeiculo(deliveriesIds) {
  return `${MAIN_BASE_URL}/report-product-client/${deliveriesIds}?t=${localStorage.getItem('t')}`
}
// **************************
// Canhoto
// **************************
// UPLOAD => Backend DOCS REPOSITORY
export function urlUploadCanhoto(delivery_id) {
  return `${DOC_BASE_URL}/canhoto/${delivery_id}`
}
// DELETE => Backend DOCS REPOSITORY
export function urlDeleteFileCanhoto(filename) {
  return `${DOC_BASE_URL}/canhoto/${filename}`
}
// **************************
// NF Devolucao Total - UPLOAD => Backend DOCS REPOSITORY
// **************************
//UPLOAD => Backend DOCS REPOSITORY
export function urlUploadNfDevolucaoTotal(delivery_id) {
  return `${DOC_BASE_URL}/nf-dev-total/${delivery_id}`
}
export function urlDeleteFileNfDevolucaoTotal(filename) {
  return `${DOC_BASE_URL}/nf-dev-total/${filename}`
}
// **************************
// NF Devolucao Parcial
// **************************
//UPLOAD => Backend DOCS REPOSITORY
export function urlUploadNfDevolucaoParcial(client_id, invoice_number) {
  return `${DOC_BASE_URL}/nf-dev-parcial/${client_id}/${invoice_number}`
}

export function urlAtualizarDeliveryInvoicePathAndNumber(delivery_id) {
  return `${MAIN_BASE_URL}/update-invoice-number-path/${delivery_id}`
}

// Update Delivery DOC PATHS : Canhoto e Devolução Total
export function urlUpdateDocPath(delivery_id) {
  return `${MAIN_BASE_URL}/update-doc-path/${delivery_id}`
}
export function buildDocPath(action, filename) {
  if (!filename) return null
  switch (action) {
    case 'canhoto':
      return `${DOC_BASE_URL}/canhotos/${filename}`
    case 'nf_dev_total':
      return `${DOC_BASE_URL}/nf_devolucao_total/${filename}`
    case 'nf_dev_parcial':
      return `${DOC_BASE_URL}/nf_devolucao_parcial/${filename}`
    default:
      throw new Error('Action incorreta')
  }
}

// Devolução Parcial
export const urlPostNotaFiscalDevolucaoParcial = `${MAIN_BASE_URL}/client-returned-invoice`

export function urlDeleteFileNfDevolucaoParcial(
  filename,
  client_returned_invoice_id,
  delivery_step_id,
) {
  return `${DOC_BASE_URL}/nf-dev-parcial/${filename}/${client_returned_invoice_id}/${delivery_step_id}`
}

export function urlDeleteNfDevolucaoParcial(invoice_id) {
  return `${MAIN_BASE_URL}/client-returned-invoice/${invoice_id}`
}

export function urlGetNfDevolucaoParcial(invoice_id) {
  return `${MAIN_BASE_URL}/client-returned-invoice/${invoice_id}`
}

export function urlGetNfsDevolucaoParcialByStep(delivery_step_id) {
  return `${MAIN_BASE_URL}/client-returned-invoices/${delivery_step_id}`
}

export function urlAssocNfDevolucaoParcialComAsFaltas(delivery_id) {
  return `${MAIN_BASE_URL}/assoc-parcial-invoice-with-missing-product/${delivery_id}`
}

export const urlPutMissingProductQteAdjusted = `${MAIN_BASE_URL}/update-missing-product-qte-adjusted`

export function urlGetInfoMissingProductStageEntrega(delivery_id) {
  return `${MAIN_BASE_URL}/missing-product-stage-entrega-info/${delivery_id}`
}

export function urlPostMissingProductStageEntrega(delivery_step_id) {
  return `${MAIN_BASE_URL}/missing-product-stage-entrega-v2/${delivery_step_id}`
}

export function urlApuracaoRetornoVeiculoEntrega(tp_id) {
  return `${MAIN_BASE_URL}/multiple-apuracao/${tp_id}`
}

export function urlGetEntregasParaApurar(tp_id) {
  return `${MAIN_BASE_URL}/export-deliveries-to-check/${tp_id}?t=${localStorage.getItem('t')}`
}

export function urlLeftoverProductByFleetId(fleet_id) {
  return `${MAIN_BASE_URL}/leftover_products/${fleet_id}`
}

export function urlLeftoverProduct() {
  return `${MAIN_BASE_URL}/leftover_products`
}

export function urlLeftoverProductInfoByCompanyId(company_id) {
  return `${MAIN_BASE_URL}/leftover_product_info/${company_id}`
}

export function urlLeftoverProductAjust(id) {
  return `${MAIN_BASE_URL}/leftover_products/${id}`
}

export function urlGetReturnedVehicles(tp_id, dataInicio, dataFim, user_id) {
  dataInicio = `${parseToMysqlFormat(new Date(dataInicio))} 00:00:00`
  dataFim = `${parseToMysqlFormat(new Date(dataFim))} 23:59:59`
  return `${MAIN_BASE_URL}/returned-vehicles/${tp_id}/?dataInicio=${dataInicio}&dataFim=${dataFim}&user_id=${user_id}`
}

export function urlgetReturnedVehiclesByNF(tp_id, dataInicio, dataFim, notaFiscal, company_id, user_id) {
  let url = `${MAIN_BASE_URL}/returned-vehicles-nf/${tp_id}?notaFiscal=${notaFiscal}`
  const dataInicioFormatted = `${parseToMysqlFormat(new Date(dataInicio))} 00:00:00`
  const dataFimFormatted = `${parseToMysqlFormat(new Date(dataFim))} 23:59:59`
  url += `&dataInicio=${dataInicioFormatted}&dataFim=${dataFimFormatted}`
  url += `&company_id=${company_id}`
  url += `&user_id=${user_id}`
  return url
}

export function urlGetVehiclesInfo(tp_id) {
  return `${MAIN_BASE_URL}/vehicles-info/${tp_id}`
}
